import { Component } from '@angular/core';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-open',
  templateUrl: './open.component.html',
  styleUrls: ['./open.component.scss']
})
export class OpenComponent {

  customers:any;

  accounts:any

  constructor(public api:ApiService) { }

  ngOnInit(){
    this.api.adminUser.subscribe((user:any)=>{
      if(user && user.ebp_id){
        this.api.post("function=getNg2Customers",{ColleagueId:user.ebp_id}).then((res:any)=>{
          this.api.post("SPDO_krolServer=select",{database:'pro_account'}).then((res2:any)=>{
            this.accounts = res2.data;
            this.customers = res.filter(item => { 
              item.account = this.accounts.find(item2=>item2.Id == item.Id);
              console.log(item.account);
              return item.FamilyName && (item.FamilyId == 'FCL00001' || item.FamilyName.indexOf('GSS') > -1 )
            }); 

          });
        });
      }
    });
  }

  resume(dt){
    if(dt.filteredValue != null){
      for(let row of dt.filteredValue){
        console.log(row.account);
      }
    }
  }
}
